import { observer } from 'mobx-react-lite'
import { MultiStepMobileWizard } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/MultiStepMobileWizard'
import { SubmitStepProps } from 'components/Wizards/MobileWizards/MultiStepMobileWizard/Types'
import { FlowProps, TextValues } from 'components/Wizards/MobileWizards/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { RefineDetails } from 'components/Wizards/MobileWizards/MobileWizard/components/RefineDetails/RefineDetails'
import { useMobileWizardCreateDoc } from 'components/Wizards/MobileWizards/hooks/useMobileWizardCreateDoc'

type Values = Pick<TextValues, 'filename' | 'topic' | 'language' | 'tone' | 'brand_kit_id'>

export const FlowZ2 = observer(({ schema, onClose, initialValues, ...props }: FlowProps<ChannelType>) => {
  const {
    meta: { channel, title },
  } = schema

  const { createDoc } = useMobileWizardCreateDoc(channel, {
    navigateToDocOnComplete: true,
    loadingToast: `Generating your ${title}`,
  })

  const handleSubmitStep = async ({ values }: SubmitStepProps<Values>) => {
    const docData: Partial<TextValues> = {
      ...values,
      filename: values.filename || `${title || 'Generated Caption'} - ${Date.now()}`,
    }
    await createDoc(docData as TextValues)
  }

  return (
    <MultiStepMobileWizard<Values>
      schema={schema}
      onClose={onClose}
      onSubmitStep={handleSubmitStep}
      initialValues={initialValues}
      {...props}
    >
      <RefineDetails submitLabel="Generate Script" />
    </MultiStepMobileWizard>
  )
})
